var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyfintoodark5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5251 2.55935C19.111 1.97341 19.111 1.02185 18.5251 0.435913C17.9391 -0.150024 16.9876 -0.150024 16.4016 0.435913L1.40161 15.4359C0.815674 16.0219 0.815674 16.9734 1.40161 17.5594C1.98755 18.1453 2.93911 18.1453 3.52505 17.5594L18.5251 2.55935ZM6.96567 2.99998C6.96567 2.20433 6.6496 1.44126 6.08699 0.878655C5.52439 0.316046 4.76132 -2.45569e-05 3.96567 -2.45569e-05C3.17002 -2.45569e-05 2.40696 0.316046 1.84435 0.878655C1.28174 1.44126 0.965674 2.20433 0.965674 2.99998C0.965674 3.79563 1.28174 4.55869 1.84435 5.1213C2.40696 5.68391 3.17002 5.99998 3.96567 5.99998C4.76132 5.99998 5.52439 5.68391 6.08699 5.1213C6.6496 4.55869 6.96567 3.79563 6.96567 2.99998ZM18.9657 15C18.9657 14.2043 18.6496 13.4413 18.087 12.8787C17.5244 12.316 16.7613 12 15.9657 12C15.17 12 14.407 12.316 13.8444 12.8787C13.2817 13.4413 12.9657 14.2043 12.9657 15C12.9657 15.7956 13.2817 16.5587 13.8444 17.1213C14.407 17.6839 15.17 18 15.9657 18C16.7613 18 17.5244 17.6839 18.087 17.1213C18.6496 16.5587 18.9657 15.7956 18.9657 15Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyfintoodark5);
export default __webpack_public_path__ + "static/media/whyfintoodark5.c171222eaa24d13570770c785a8e88b6.svg";
export { ForwardRef as ReactComponent };